import React, { useState, useEffect } from "react";
import authService from "../../../Services/authService";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../../Services/CartContext";

export default function PackagesQuantityControlButton({
  id,
  name,
  price,
  visit_type,
  quantity: externalQuantity = 0,
  className,
  
}) {
  const navigate = useNavigate();
  const { addItem, removeItem, fetchCartCount } = useCart();
  const [quantity, setQuantity] = useState(externalQuantity);
  const [isAdded, setIsAdded] = useState(externalQuantity > 0);

  useEffect(() => {
    setQuantity(externalQuantity);
    setIsAdded(externalQuantity > 0);
  }, [externalQuantity]);

  const handleAdd = () => {
    const user = authService.getCurrentuser();
    if (!user) {
      localStorage.setItem('pendingCartItem', JSON.stringify({
        type: "package",
        name,
        test_id: id,
        quantity: 1,
        price,
        overall_price: price,
        preparation: "",
        organization_id: 1,
        visit_type,
      }));
      navigate("/login");
      return;
    }

    const token = authService.getCurrentUsertoken();
    fetch(authService.getApiUrl() + "cart", {
      method: "POST",
      body: JSON.stringify({
        user_id: user.id,
        type: "package",
        name,
        test_id: id,
        quantity: 1,
        price,
        overall_price: price,
        preparation: "",
        organization_id: 1,
        visit_type,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then(() => {
        setIsAdded(true);
        setQuantity(1);
        fetchCartCount();
      })
      .catch((err) => {
        console.error("Error adding item to cart:", err);
      });
  };

  const handleIncrement = () => {
    const user = authService.getCurrentuser();
    if (!user) {
      navigate("/login");
      return;
    }

    const updatedQuantity = quantity + 1;
    setQuantity(updatedQuantity);

    const token = authService.getCurrentUsertoken();
    fetch(authService.getApiUrl() + "cart/update", {
      method: "PUT",
      body: JSON.stringify({
        user_id: user.id,
        test_id: id,
        quantity: updatedQuantity,
        price,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then(() => {
        fetchCartCount();
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleDecrement = () => {
    const user = authService.getCurrentuser();
    if (!user) {
      navigate("/login");
      return;
    }

    const updatedQuantity = quantity - 1;

    if (updatedQuantity < 1) {
      // Item should be removed or reverted to 'Add'
      setQuantity(0);
      setIsAdded(false);
    } else {
      setQuantity(updatedQuantity);
    }

    const token = authService.getCurrentUsertoken();
    fetch(authService.getApiUrl() + "cart/update", {
      method: "PUT",
      body: JSON.stringify({
        user_id: user.id,
        test_id: id,
        quantity: updatedQuantity < 1 ? 0 : updatedQuantity,
        price,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then(() => {
        fetchCartCount();
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  return (
    <div className="flex items-center justify-between py-1">
      {quantity < 1 ? (
        <span
          onClick={handleAdd}
          className={`text-sm font-medium ${className === "text-white" ? 'text-white' : 'text-[#951C25]'} cursor-pointer`}
        >
          Add &nbsp;+
        </span>
      ) : (
        <div className="flex items-center space-x-3">
          <button
            onClick={handleDecrement}
            className={`text-sm font-medium ${className === "text-white" ? 'text-white' : 'text-[#951C25]'} `}
            aria-label="Decrease quantity"
          >
            −
          </button>
          <span className={`text-sm font-medium ${className === "text-white" ? 'text-white' : 'text-[#951C25]'} `}>{quantity}</span>
          <button
            onClick={handleIncrement}
            className={`text-sm font-medium ${className === "text-white" ? 'text-white' : 'text-[#951C25]'} cursor-pointer`}
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>
      )}
    </div>
  );
}
